import { endPoints } from "../../constant/api_constants/url";
import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";
import { consoleLog } from "../../utils/consoleLog/consoleLog";

/**
 * "Share whole cart" API layer.
 *
 * - createSharedCartAPI: store a cart snapshot (the shared-details payload) so it
 *   can be opened later via `/shared-cart/<id>`. The backend stamps the sharer's
 *   userId from the JWT — do NOT trust a body userId for that. Returns { id }.
 * - getSharedCartAPI: fetch a stored snapshot by id (recipient side).
 * - getSharedCartDetailsAPI: reconstruct fresh flight + hotel + activity details
 *   from the stored snapshot ids (proxies the booking engine
 *   `/be/v1/search/shared-details`). Used to rebuild a bookable review.
 */

export interface iSharedCartPayload {
  // The viewer/sharer userId sent to the shared-details engine call. On share
  // this is the sharer; on open it is the recipient (their own booking context).
  userId?: string;
  flight?: { id: string; fareId: string } | null;
  hotels?: Array<{
    uniqueId: string;
    sessionId: string;
    hotelId: string;
    unicaId: string;
    // Persisted at share time so the recipient's prebook can reuse them — the
    // /search/shared-details response does NOT return these session ids.
    preBookId?: string;
    roomPricingSessionId?: string;
  }>;
  activity?: Array<{ uniqueId: string; productOptionCode: string; startTime: string }>;
}

export const createSharedCartAPI = async (
  accessJWT: string,
  payLoad: { data: iSharedCartPayload; tripName?: string }
) => {
  consoleLog(["CREATE SHARED CART PAYLOAD", payLoad]);
  return await fetchApi(accessJWT, endPoints.createSharedCart, API_METHODS.POST, payLoad);
};

export const getSharedCartAPI = async (accessJWT: string, id: string) => {
  return await fetchApi(accessJWT, endPoints.getSharedCart, API_METHODS.GET, null, { id });
};

export const getSharedCartDetailsAPI = async (accessJWT: string, payLoad: iSharedCartPayload) => {
  consoleLog(["SHARED CART DETAILS PAYLOAD", payLoad]);
  return await fetchApi(accessJWT, endPoints.sharedCartDetails, API_METHODS.POST, payLoad);
};
